import { Component, Input, NgZone, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { RecordingSetupPreviewService, SetupPreviewAngle } from 'src/app/data/recording-setup-preview.service';

const DEFAULT_ASPECT_RATIO = 16 / 9;

@Component({
  selector: 'app-recording-setup-preview',
  templateUrl: './recording-setup-preview.component.html',
  styleUrls: ['./recording-setup-preview.component.scss'],
  standalone: false
})
export class RecordingSetupPreviewComponent implements OnChanges, OnDestroy {
  @Input() setupPath: string | null = null;
  @Input() maxHeight = 220;

  angles: SetupPreviewAngle[] = [];
  failedImages = new Set<string>(); // snapshot links that no longer load
  loading = false;
  private subscription: Subscription | null = null;

  constructor(private setupPreview: RecordingSetupPreviewService, private zone: NgZone) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.setupPath) {
      return;
    }
    this.subscription?.unsubscribe();
    this.subscription = null;
    this.angles = [];
    this.loading = Boolean(this.setupPath);
    if (!this.setupPath) {
      return;
    }
    this.subscription = this.setupPreview.getAngles(this.setupPath).subscribe({
      // The Firestore listeners can call back outside Angular's zone: without run() the view only refreshes on the next event
      next: (angles) => this.zone.run(() => {
        this.angles = angles;
        this.loading = false;
      }),
      complete: () => this.zone.run(() => {
        this.loading = false;
      }),
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  hasImage(angle: SetupPreviewAngle): boolean {
    return Boolean(angle.imgUrl) && !this.failedImages.has(angle.imgUrl);
  }

  aspectRatio(angle: SetupPreviewAngle): string | null {
    return angle.width && angle.height ? `${angle.width} / ${angle.height}` : null;
  }

  /** Caps the height through the width, so the image keeps its proportions on a narrow container. */
  maxWidth(angle: SetupPreviewAngle): string {
    const ratio = angle.width && angle.height ? angle.width / angle.height : DEFAULT_ASPECT_RATIO;
    return `${Math.round(this.maxHeight * ratio)}px`;
  }
}
